import { EpimsBaseEntityDto } from './epim-base.dto';
export class ClubDto extends EpimsBaseEntityDto {

    ClubId: string;

    ClubName: string;
    CountryId: string;


}
